import { linkExistingProfile, skipSSOLink, submitGradesAndTopics } from '../actions/teacherRegistrationActions';

const config = {
  actionCreators: {
    linkExistingProfile,
    skipSSOLink,
    submitGradesAndTopics,
  },
};

export default config;
